<template>
  <div>
    <applicationForm :eventStatusId="eventStatusId" :eventStatusDetail="eventStatusDetail" :formType="formType"></applicationForm>
  </div>
</template>

<script>
import { getEventStatusDetail } from "@/api/parent/eventStatus";
import applicationForm from "./components/applicationForm.vue";
export default {
  components: {
    applicationForm,
  },
  props: {
    eventStatusId: {
      type: Number,
      default: 0,
    },
    formType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
        eventStatusDetail: {}
    }
  },
  created() {
    this.getEventStatusDetail();
  },
  methods: {
    getEventStatusDetail() {
      getEventStatusDetail(this.eventStatusId).then((res) => {
          this.eventStatusDetail = res.data;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
</style>